import { useMemo } from 'react';
import { TextRepository } from './TextRepository';
import type { DBPath } from 'balus-common';

export const useTextRepository = (path: DBPath): TextRepository => {
  return useMemo(() => {
    return new TextRepository(path);
  }, [path]);
};
